const InfoItem = ({ label, value, mono = false }) => (
	<div className="space-y-1">
		<div className="text-gray-500 text-xs">{label}</div>
		<div className={`text-sm font-medium ${mono ? "font-mono" : ""}`}>
			{value || <span className="text-gray-400">—</span>}
		</div>
	</div>
);

export default InfoItem;